/* eslint @typescript-eslint/no-redundant-type-constituents: 0 */
import { IntlMessageFormat } from 'intl-messageformat';

const _search_fr = new IntlMessageFormat([{ type: 0, value: 'Rechercher' }], 'fr');

export function search(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _search_fr.format(args) as unknown as string;
    }

    return _search_fr.format(args) as unknown as string;
}

const _close_fr = new IntlMessageFormat([{ type: 0, value: 'Fermer' }], 'fr');

export function close(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _close_fr.format(args) as unknown as string;
    }

    return _close_fr.format(args) as unknown as string;
}

const _inbox_fr = new IntlMessageFormat([{ type: 0, value: 'Messagerie' }], 'fr');

export function inbox(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _inbox_fr.format(args) as unknown as string;
    }

    return _inbox_fr.format(args) as unknown as string;
}

const _open_to_inbox_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Ouvrir dans la messagerie' }],
    'fr',
);

export function open_to_inbox(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _open_to_inbox_fr.format(args) as unknown as string;
    }

    return _open_to_inbox_fr.format(args) as unknown as string;
}

const _back_to_inbox_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Retour sur la messagerie' }],
    'fr',
);

export function back_to_inbox(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _back_to_inbox_fr.format(args) as unknown as string;
    }

    return _back_to_inbox_fr.format(args) as unknown as string;
}

const _back_to_list_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Retour à la liste' }],
    'fr',
);

export function back_to_list(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _back_to_list_fr.format(args) as unknown as string;
    }

    return _back_to_list_fr.format(args) as unknown as string;
}

const _back_to_return_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Retourner en arrière' }],
    'fr',
);

export function back_to_return(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _back_to_return_fr.format(args) as unknown as string;
    }

    return _back_to_return_fr.format(args) as unknown as string;
}

const _cancel_fr = new IntlMessageFormat([{ type: 0, value: 'Annuler' }], 'fr');

export function cancel(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _cancel_fr.format(args) as unknown as string;
    }

    return _cancel_fr.format(args) as unknown as string;
}

const _confirm_fr = new IntlMessageFormat([{ type: 0, value: 'Confirmer' }], 'fr');

export function confirm(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _confirm_fr.format(args) as unknown as string;
    }

    return _confirm_fr.format(args) as unknown as string;
}

const _confirmation_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Confirmation' }],
    'fr',
);

export function confirmation(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _confirmation_fr.format(args) as unknown as string;
    }

    return _confirmation_fr.format(args) as unknown as string;
}

const _save_fr = new IntlMessageFormat([{ type: 0, value: 'Enregistrer' }], 'fr');

export function save(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _save_fr.format(args) as unknown as string;
    }

    return _save_fr.format(args) as unknown as string;
}

const _loading_fr = new IntlMessageFormat([{ type: 0, value: 'Chargement' }], 'fr');

export function loading(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _loading_fr.format(args) as unknown as string;
    }

    return _loading_fr.format(args) as unknown as string;
}

const _loading_etc_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Chargement...' }],
    'fr',
);

export function loading_etc(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _loading_etc_fr.format(args) as unknown as string;
    }

    return _loading_etc_fr.format(args) as unknown as string;
}

const _submit_fr = new IntlMessageFormat([{ type: 0, value: 'Envoyer' }], 'fr');

export function submit(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _submit_fr.format(args) as unknown as string;
    }

    return _submit_fr.format(args) as unknown as string;
}

const _submitting_fr = new IntlMessageFormat([{ type: 0, value: 'Envoi...' }], 'fr');

export function submitting(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _submitting_fr.format(args) as unknown as string;
    }

    return _submitting_fr.format(args) as unknown as string;
}

const _followed_fr = new IntlMessageFormat([{ type: 0, value: 'Suivi' }], 'fr');

export function followed(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _followed_fr.format(args) as unknown as string;
    }

    return _followed_fr.format(args) as unknown as string;
}

const _follow_fr = new IntlMessageFormat([{ type: 0, value: 'Suivre' }], 'fr');

export function follow(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _follow_fr.format(args) as unknown as string;
    }

    return _follow_fr.format(args) as unknown as string;
}

const _url_of_video_not_valid_fr = new IntlMessageFormat(
    [{ type: 0, value: "L'url de la vidéo n'est pas valide" }],
    'fr',
);

export function url_of_video_not_valid(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _url_of_video_not_valid_fr.format(args) as unknown as string;
    }

    return _url_of_video_not_valid_fr.format(args) as unknown as string;
}

const _validate_fr = new IntlMessageFormat([{ type: 0, value: 'Valider' }], 'fr');

export function validate(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _validate_fr.format(args) as unknown as string;
    }

    return _validate_fr.format(args) as unknown as string;
}

const _choose_this_video_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Choisir cette vidéo' }],
    'fr',
);

export function choose_this_video(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _choose_this_video_fr.format(args) as unknown as string;
    }

    return _choose_this_video_fr.format(args) as unknown as string;
}

const _choose_video_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Choisir une vidéo' }],
    'fr',
);

export function choose_video(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _choose_video_fr.format(args) as unknown as string;
    }

    return _choose_video_fr.format(args) as unknown as string;
}

const _clear_input_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Effacer le champs' }],
    'fr',
);

export function clear_input(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _clear_input_fr.format(args) as unknown as string;
    }

    return _clear_input_fr.format(args) as unknown as string;
}

const _previous_fr = new IntlMessageFormat([{ type: 0, value: 'Précédent' }], 'fr');

export function previous(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _previous_fr.format(args) as unknown as string;
    }

    return _previous_fr.format(args) as unknown as string;
}

const _next_fr = new IntlMessageFormat([{ type: 0, value: 'Suivant' }], 'fr');

export function next(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _next_fr.format(args) as unknown as string;
    }

    return _next_fr.format(args) as unknown as string;
}

const _x_minute_fr = new IntlMessageFormat(
    [
        {
            type: 6,
            value: 'count',
            options: {
                one: { value: [{ type: 7 }, { type: 0, value: ' minute' }] },
                other: { value: [{ type: 7 }, { type: 0, value: ' jours' }] },
            },
            offset: 0,
            pluralType: 'cardinal',
        },
    ],
    'fr',
);

export function x_minute(args: { count: number }, lang: string): string {
    if (lang.startsWith('fr')) {
        return _x_minute_fr.format(args) as unknown as string;
    }

    return _x_minute_fr.format(args) as unknown as string;
}

const _x_hour_fr = new IntlMessageFormat(
    [
        {
            type: 6,
            value: 'count',
            options: {
                one: { value: [{ type: 7 }, { type: 0, value: ' minute' }] },
                other: { value: [{ type: 7 }, { type: 0, value: ' jours' }] },
            },
            offset: 0,
            pluralType: 'cardinal',
        },
    ],
    'fr',
);

export function x_hour(args: { count: number }, lang: string): string {
    if (lang.startsWith('fr')) {
        return _x_hour_fr.format(args) as unknown as string;
    }

    return _x_hour_fr.format(args) as unknown as string;
}

const _x_day_fr = new IntlMessageFormat(
    [
        {
            type: 6,
            value: 'count',
            options: {
                one: { value: [{ type: 7 }, { type: 0, value: ' jour' }] },
                other: { value: [{ type: 7 }, { type: 0, value: ' jours' }] },
            },
            offset: 0,
            pluralType: 'cardinal',
        },
    ],
    'fr',
);

export function x_day(args: { count: number }, lang: string): string {
    if (lang.startsWith('fr')) {
        return _x_day_fr.format(args) as unknown as string;
    }

    return _x_day_fr.format(args) as unknown as string;
}

const _x_week_fr = new IntlMessageFormat(
    [
        {
            type: 6,
            value: 'count',
            options: {
                one: { value: [{ type: 7 }, { type: 0, value: ' semaine' }] },
                other: { value: [{ type: 7 }, { type: 0, value: ' semaines' }] },
            },
            offset: 0,
            pluralType: 'cardinal',
        },
    ],
    'fr',
);

export function x_week(args: { count: number }, lang: string): string {
    if (lang.startsWith('fr')) {
        return _x_week_fr.format(args) as unknown as string;
    }

    return _x_week_fr.format(args) as unknown as string;
}

const _select_participant_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Sélectionne un participant' }],
    'fr',
);

export function select_participant(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _select_participant_fr.format(args) as unknown as string;
    }

    return _select_participant_fr.format(args) as unknown as string;
}

const _to_post_fr = new IntlMessageFormat([{ type: 0, value: 'Poster' }], 'fr');

export function to_post(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _to_post_fr.format(args) as unknown as string;
    }

    return _to_post_fr.format(args) as unknown as string;
}

const _is_posting_fr = new IntlMessageFormat(
    [{ type: 0, value: 'En train de poster...' }],
    'fr',
);

export function is_posting(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _is_posting_fr.format(args) as unknown as string;
    }

    return _is_posting_fr.format(args) as unknown as string;
}

const _open_fr = new IntlMessageFormat([{ type: 0, value: 'Ouvrir' }], 'fr');

export function open(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _open_fr.format(args) as unknown as string;
    }

    return _open_fr.format(args) as unknown as string;
}

const _nb_results_fr = new IntlMessageFormat(
    [
        {
            type: 6,
            value: 'count',
            options: {
                one: { value: [{ type: 7 }, { type: 0, value: ' résultat ' }] },
                other: { value: [{ type: 7 }, { type: 0, value: ' résultats' }] },
            },
            offset: 0,
            pluralType: 'cardinal',
        },
    ],
    'fr',
);

export function nb_results(args: { count: number }, lang: string): string {
    if (lang.startsWith('fr')) {
        return _nb_results_fr.format(args) as unknown as string;
    }

    return _nb_results_fr.format(args) as unknown as string;
}

const _delete__fr = new IntlMessageFormat([{ type: 0, value: 'Supprimer' }], 'fr');

export function delete_(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _delete__fr.format(args) as unknown as string;
    }

    return _delete__fr.format(args) as unknown as string;
}

const _select_file_placeholder_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Choisissez un fichier' }],
    'fr',
);

export function select_file_placeholder(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _select_file_placeholder_fr.format(args) as unknown as string;
    }

    return _select_file_placeholder_fr.format(args) as unknown as string;
}

const _read_more_fr = new IntlMessageFormat([{ type: 0, value: 'Lire la suite' }], 'fr');

export function read_more(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _read_more_fr.format(args) as unknown as string;
    }

    return _read_more_fr.format(args) as unknown as string;
}

const _form_data_processing_notice_fr = new IntlMessageFormat(
    [
        {
            type: 0,
            value: 'Les informations recueillies via ce canal font l’objet d’un traitement de données\npersonnelles destiné à Go Africa Online dans le cadre de la gestion des contacts.\nVous disposez d’un droit d’accès, de modification et de suppression des données\nvous concernant. Pour plus d’informations, veuillez consulter\n[url hrefCode="politique-confidentialite" target="_blank" obfuscate="true"]notre politique de confidentialité[/url].',
        },
    ],
    'fr',
);

export function form_data_processing_notice(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _form_data_processing_notice_fr.format(args) as unknown as string;
    }

    return _form_data_processing_notice_fr.format(args) as unknown as string;
}
